import React from 'react';

const GetStarted = () => {
		return (
			<div className="gs-container">
				<h2 className="vk-title gs-title">How do I get started?</h2>
                <div className="gs-steps-container">
                    <div className="gss-number">1.</div>
                    <p className="gss-text">Create a free account here, or sign back in here</p>
                </div>
                <div className="gs-steps-container">
                    <div className="gss-number">2.</div>
                    <p className="gss-text">Create up to 5 vizcodes, free of charge</p>
                </div>
                <div className="gs-steps-container">
                    <div className="gss-number">3.</div>
                    <p className="gss-text">Print out your VizCode, or visit our store for reusable, wearable VizKidz <products></products></p>
                </div>
                <p className="gss-footnote">Enjoy that little extra peace of mind</p>
			</div>
		);
}

export default GetStarted;



// WEBPACK FOOTER //
// ./src/components/home/getStartedPane.js